module.exports = __webpack_public_path__ + "img/brainpunks_logo.b7bea1f5.png";